import { render } from "./CargoQuestionnaire.vue?vue&type=template&id=17249f8c"
import script from "./CargoQuestionnaire.vue?vue&type=script&lang=js"
export * from "./CargoQuestionnaire.vue?vue&type=script&lang=js"

import "./CargoQuestionnaire.vue?vue&type=style&index=0&id=17249f8c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__